<template>
  <div class="index" v-cloak>
    <div
      class="follow acea-row row-between-wrapper"
      v-if="followHid && isWeixin"
    >
      <div>点击“立即关注”即可关注公众号</div>
      <div class="acea-row row-middle">
        <div class="bnt" @click="followTap">立即关注</div>
        <span class="iconfont icon-guanbi" @click="closeFollow"></span>
      </div>
    </div>
    <div class="followCode" v-if="followCode">
      <div class="pictrue"><img :src="followUrl" /></div>
      <div class="mask" @click="closeFollowCode"></div>
    </div>
    <div class="header acea-row row-center-wrapper">
      <div class="logo"><img :src="logoUrl" /></div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
    </div>
    <div class="top_nav" :class="{ _bottom: cateList.length > 4 }">
      <div class="acea-row">
        <a href="javascript:;" @click="changenav(-1)">
          <div :class="{ on: navindex == -1 }">
            首页
          </div>
        </a>
        <a
          href="javascript:;"
          @click="changenav(index, item)"
          v-for="(item, index) in cateList"
          :key="index"
        >
          <div :class="{ on: navindex == index }">
            {{ item.cate_name }}
          </div>
        </a>
      </div>
    </div>
    <div class="claBox" v-if="claList.length && navindex != -1">
      <div class="acea-row">
        <div class="claItem" :class="{ claOn: !claTab }" @click="onClass('')">
          <img src="../../assets/images/quanbu.png" alt="" class="claImg" />
          <div class="claName">
            全部
          </div>
        </div>
        <div
          class="claItem"
          v-for="(item, index) in claList"
          :key="index"
          @click="onClass(item, index)"
          :class="{ claOn: claTab == item.id }"
        >
          <img :src="item.pic" alt="" class="claImg" />
          <div class="claName">
            {{ item.cate_name }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="navindex == -1">
      <div class="slider-banner banner">
        <swiper :options="swiperOption" v-if="banner.length > 0">
          <swiper-slide v-for="(item, index) in banner" :key="index">
            <img :src="item.pic" v-viewer />
          </swiper-slide>
          <div
            class="swiper-pagination paginationBanner"
            slot="pagination"
          ></div>
        </swiper>
      </div>
      <div class="nav_news">
        <div class="nav acea-row">
          <router-link
            :to="item.wap_url ? item.wap_url : ''"
            class="item"
            v-for="(item, index) in menus"
            :key="index"
          >
            <div class="pictrue"><img v-lazy="item.pic" alt="img" /></div>
            <div>{{ item.name }}</div>
          </router-link>
        </div>
        <div class="news acea-row row-between-wrapper">
          <div class="pictrue"><img src="@assets/images/news.png" /></div>
          <div class="swiper-no-swiping new-banner">
            <swiper
              class="swiper-wrapper"
              :options="swiperRoll"
              v-if="roll.length > 0"
            >
              <swiper-slide
                class="swiper-slide"
                v-for="(item, index) in roll"
                :key="index"
              >
                <router-link
                  :to="item.wap_url ? item.wap_url : ''"
                  class="acea-row row-between-wrapper"
                >
                  <div class="text acea-row row-between-wrapper">
                    <div class="label" v-if="item.show === '是'">最新</div>
                    <div class="newsTitle line1">{{ item.info }}</div>
                  </div>
                  <!-- <div class="iconfont icon-xiangyou"></div> -->
                </router-link>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div
        class="specialArea acea-row row-between-wrapper"
        v-if="activityOne.wap_link !== undefined || activity.length"
      >
        <router-link
          :to="activityOne.wap_link ? activityOne.wap_link : ''"
          v-if="activityOne.wap_link !== undefined"
          class="assemble"
        >
          <img v-lazy="activityOne.pic" alt="img" />
          <div class="text">
            <div class="name">{{ activityOne.title }}</div>
            <div class="infor">{{ activityOne.info }}</div>
          </div>
        </router-link>
        <div class="list acea-row row-column-between">
          <router-link
            :to="item.wap_link ? item.wap_link : ''"
            class="item"
            v-for="(item, index) in activity"
            :key="index"
          >
            <img v-lazy="item.pic" alt="img" />
            <div class="text">
              <div class="name">{{ item.title }}</div>
              <div class="infor">{{ item.info }}</div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="wrapper" v-if="info.fastList.length > 0">
        <div class="title acea-row row-between-wrapper">
          <div class="text">
            <div class="name line1">快速选择</div>
            <div class="line1">{{ info.fastInfo }}</div>
          </div>
          <router-link :to="'/category'" class="more"
            >更多<span class="iconfont icon-jiantou"></span
          ></router-link>
        </div>
        <div class="scroll-product">
          <swiper class="swiper-wrapper" :options="swiperScroll">
            <swiper-slide
              v-for="(item, index) in info.fastList"
              :key="index"
              class="swiper-slide"
            >
              <router-link
                :to="{
                  path: '/goods_list',
                  query: { id: item.id, title: item.cate_name }
                }"
              >
                <div class="img-box">
                  <img v-lazy="item.pic" alt="img" />
                </div>
                <div class="pro-info line1">{{ item.cate_name }}</div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="hotList" v-if="likeInfo.length > 0">
        <div class="hot-bg">
          <div class="title acea-row row-between-wrapper">
            <div class="text line1">
              <span class="label">热卖专区</span>
            </div>
            <router-link
              :to="{ path: '/activity/pinklist?type=hot' }"
              class="more"
            >
              <img src="@assets/images/gobtn.png" alt="" />
            </router-link>
          </div>
        </div>
        <div class="list acea-row row-middle">
          <router-link
            :to="{ path: '/detail/' + item.id }"
            class="item"
            v-for="(item, index) in likeInfo"
            :key="index"
          >
            <div class="pictrue">
              <img v-lazy="item.image" alt="img" />
            </div>
            <div class="name line1">{{ item.store_name }}</div>
            <div class="acea-row btie">
              <span class="label">补贴</span>
              <span class="price">￥{{ item.pt_info.ctj }}</span>
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="newGoodsBananr">
        <div class="adver">
          <img v-lazy="newGoodsBananr" alt="img" />
        </div>
      </div>
    </div>
    <div class="pinktitle">
      <img class="titleimg" src="@assets/images/pinktitle.png" alt="" />
      <div class="pinklist" v-if="navindex == -1">
        <div
          class="pinkitem acea-row row-between-wrapper"
          v-for="(item, index) in info.bastList"
          :key="index"
          @click="goDetail(item)"
        >
          <img class="goodsimg" :src="item.image" />
          <div class="infos">
            <div class="store_name line2">{{ item.store_name }}</div>
            <div class="price_member acea-row row-between-wrapper">
              <div class="price acea-row">
                <div class="price_1">
                  ￥<span>{{ item.price }}</span>
                </div>
                <div class="ot_price">￥{{ item.ot_price }}</div>
              </div>
              <div class="pinkmember">
                <div v-if="indexx < 2">
                  <img
                    class="avatar"
                    v-for="(itemm, indexx) in item.pt_info.user"
                    :src="itemm.avatar"
                    :key="indexx"
                  />
                </div>
                <img class="avatar" src="@assets/images/more_btn.png" />
              </div>
            </div>
            <div
              class="btns acea-row row-between-wrapper"
              v-if="item.istype == 0"
            >
              <div class="left">
                <div class="a">
                  {{ item.pt_info.ptnum }}人拼团，{{
                    item.pt_info.zjnum
                  }}人买到产品
                </div>
                <div class="b">
                  {{ item.pt_info.bznum }}人奖励{{ item.pt_info.ctj }}元红包
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="info.bastList.length == 0"
          class="nolist"
          style="width: 100%;line-height: 12vw;text-align: center;color: #999999;font-size: 4vw;"
        >
          暂无商品~
        </div>
      </div>
      <div class="pinklist" v-else>
        <div
          class="pinkitem acea-row row-between-wrapper"
          v-for="(item, index) in goodslist"
          :key="index"
          @click="goDetail(item)"
        >
          <img class="goodsimg" :src="item.image" />
          <div class="infos">
            <div class="store_name line2">{{ item.store_name }}</div>
            <div class="price_member acea-row row-between-wrapper">
              <div class="price acea-row">
                <div class="price_1">
                  ￥<span>{{ item.price }}</span>
                </div>
                <div class="ot_price">￥{{ item.ot_price }}</div>
              </div>
              <div class="pinkmember">
                <div v-if="indexx < 2">
                  <img
                    class="avatar"
                    v-for="(itemm, indexx) in item.pt_info.user"
                    :src="itemm.avatar"
                    :key="indexx"
                  />
                </div>
                <img class="avatar" src="@assets/images/more_btn.png" />
              </div>
            </div>
            <div class="btns acea-row row-between-wrapper">
              <div class="left">
                <div class="a">
                  {{ item.pt_info.ptnum }}人拼团，{{
                    item.pt_info.zjnum
                  }}人买到产品
                </div>
                <div class="b">
                  {{ item.pt_info.bznum }}人奖励{{ item.pt_info.ctj }}}元红包
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="goodslist.length == 0"
          class="nolist"
          style="width: 100%;line-height: 12vw;text-align: center;color: #999999;font-size: 4vw;"
        >
          暂无商品~
        </div>
      </div>
    </div>
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>

    <div style="height:1.2rem;"></div>
    <div>
      <iframe
        v-if="mapKey && !isWeixin"
        ref="geoPage"
        width="0"
        height="0"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/tools/geolocation?key=' +
            mapKey +
            '&referer=myapp'
        "
      >
      </iframe>
    </div>
    <!-- <div
      v-if="!userInfo.pay_count"
      @click="onClickshow"
      class="acea-row newbtn row-center-wrapper"
    >
      <span>新</span>
      <span>人</span>
      <span>专</span>
      <span>区</span>
    </div> -->
    <div
      v-if="show == 1 && !userInfo.pay_count"
      class="mask"
      @click="onClickHide"
    ></div>
    <div v-show="show == 1 && !userInfo.pay_count" class="coupon_wrapper">
      <div
        class="wrapper"
        :style="{
          backgroundImage:
            'url(' + base_url + '/uploads/routine/imgs/coupon_bg.png)'
        }"
      >
        <div class="list acea-row row-between-wrapper">
          <div
            class="item"
            @click="goDetail(item)"
            v-for="(item, index) in newlist"
            :key="index"
          >
            <div class="title1">补贴{{ item.pt_info.ctj }}元</div>
            <img class="goods_img" :src="item.image" />
            <div class="bottom acea-row row-between-wrapper">
              <div class="a">￥{{ item.ot_price }}</div>
              <div class="b">￥{{ item.price }}</div>
            </div>
          </div>
        </div>
        <router-link class="btn" to="/activity/pinklist?type=new"></router-link>
      </div>
      <img
        class="closebtn"
        @click="onClickHide"
        src="@assets/images/closebtn.png"
      />
    </div>
    <div class="mask acea-row row-middle row-center" v-if="poputShow">
      <div class="mask_com">
        <div class="com_title">
          {{ poput_title }}
        </div>
        <div class="com_com">
          {{ poput_content }}
        </div>
        <div class="com_but" @click="onPoput">
          关闭
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUser } from "@api/user";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare, follow } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { getCategory, getProductslist } from "@api/store";
import { goShopDetail } from "@libs/order";
import { VUE_APP_IMG_URL } from "@utils";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
// if (!localStorage.getItem("show")) {
//   localStorage.setItem("show", 1);
// }
export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    CouponWindow
  },
  props: {},
  data: function() {
    return {
      goodslist: [],
      base_url: VUE_APP_IMG_URL,
      newlist: [],
      userInfo: {
        pay_count: 0
      },
      // show: localStorage.getItem("show"),
      show: false,
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      cateList: [],
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      show_newarea: false,
      navindex: -1,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        }
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerdiv: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerdiv: "auto",
        observer: true,
        observeParents: true
      },
      mapKey: "",
      poput_title: "",
      poput_content: "",
      poputShow: 0,
      claList: [],
      claTab: ""
    };
  },
  created() {
    vm = this;
  },
  beforeDestroy() {
    this.show = 2;
    localStorage.setItem("show", 2);
  },
  mounted: function() {
    this.getFollow();
    this.getCategory();
    this.User();
    this.getProductslist();
    let that = this;
    getHomeData().then(res => {
      that.poput_title = res.data.home_popup_title;
      that.poput_content = res.data.home_popup_content;
      if (
        !localStorage.getItem("poputShow") &&
        res.data.home_popup_switch == 1
      ) {
        that.poputShow = true;
      }
      that.mapKey = res.data.tengxun_map_key;
      cookie.set(MAPKEY, that.mapKey);
      that.logoUrl = res.data.logoUrl;
      that.newGoodsBananr = res.data.newGoodsBananr;
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(
        that,
        "lovely",
        res.data.lovely.length ? res.data.lovely[0] : {}
      );
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.subscribe = res.data.subscribe;
      if (!that.subscribe && that.followUrl) {
        setTimeout(function() {
          that.followHid = true;
        }, 200);
      } else {
        that.followHid = false;
      }
      if (res.data.site_name) document.title = res.data.site_name;
      that.setOpenShare();
      this.showCoupon =
        !cookie.has(HAS_COUPON_WINDOW) &&
        res.data.couponList.some(coupon => coupon.is_use);
      if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) this.getWXLocation();
    });
  },
  methods: {
    onClass(item) {
      this.claTab = item.id || "";
      let sid = item.id ? item.id : this.cateList[this.navindex].id;
      let data = {
        sid: sid,
        page: 1,
        limit: 10000
      };
      getProductslist(data)
        .then(res => {
          this.goodslist = res.data;
        })
        .catch(res => {
          console.log(res);
        });
    },
    onPoput() {
      this.poputShow = false;
      localStorage.setItem("poputShow", true);
    },
    changenav(index, item) {
      this.navindex = index;
      if (index !== -1) {
        this.claList = this.cateList[index].children;
        let data = {
          sid: item.id,
          page: 1,
          limit: 10000
        };
        getProductslist(data)
          .then(res => {
            this.goodslist = res.data;
          })
          .catch(res => {
            console.log(res);
          });
      }
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo.pay_count = res.data.pay_count;
      });
    },
    // 关闭新人专区弹窗
    onClickHide() {
      this.show = 2;
      localStorage.setItem("show", 2);
    },
    // 关闭新人专区弹窗
    onClickshow() {
      this.show = 1;
      localStorage.setItem("show", 1);
    },
    // 新人专区列表
    getProductslist: function() {
      let data = {
        id: 23,
        page: 1,
        limit: 3
      };
      getProductslist(data)
        .then(res => {
          console.log(res);
          this.newlist = res.data;
        })
        .catch(res => {
          console.log(res);
        });
    },
    // 分类列表
    getCategory() {
      getCategory()
        .then(res => {
          console.log(res);
          this.cateList = res.data;
        })
        .catch(res => {
          console.log(res);
        });
    },
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url
        });
      }
    },
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey)
          console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then(res => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    showNew() {
      this.show_newarea = true;
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
[v-cloak] {
  display: none;
}
.index {
  background-color: #f1f1f1;
}
.coupon_wrapper {
  position: fixed;
  width: 90vw;
  top: 20vh;
  left: 0;
  right: 0;
  margin: 5vw auto 0;
  z-index: 556;
  .wrapper {
    width: 90vw;
    height: 113vw;
    background-size: 100% 100%;
    padding: 59vw 10vw 0;
    .list {
      // background-color: #fff;
      height: 32vw;
      .item {
        width: 22.4vw;
        height: 32vw;
        border-radius: 1vw;
        background-color: #fff;
        .title1 {
          width: 100%;
          height: 4vw;
          background-color: #fbe1b0;
          color: #af6c1d;
          border-radius: 1vw 1vw 0 0;
          font-size: 2.67vw;
          text-align: center;
        }
        .goods_img {
          width: 22.4vw;
          height: 22.4vw;
        }
        .bottom {
          width: 20.8vw;
          background-color: #e2e2e2;
          font-size: 2.4vw;
          height: 3.73vw;
          border-radius: 1.9vw;
          margin: 0.5vw auto 0;
          .a {
            width: 50%;
            color: #999999;
            text-decoration: line-through;
          }
          .b {
            text-align: center;
            width: 50%;
            color: #fff;
            background-color: #ff4142;
            border-radius: 1.9vw;
          }
        }
      }
    }
    .btn {
      display: inline-block;
      width: 60vw;
      height: 12vw;
      margin: 3vw auto 0;
    }
  }
  .closebtn {
    width: 8.27vw;
    height: 8.27vw;
    margin: 0 40.9vw;
  }
}
.newbtn {
  position: fixed;
  right: 0;
  flex-direction: column;
  top: 0;
  bottom: 0;
  margin: auto 0;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  width: 6vw;
  text-align: center;
  height: 25vw;
}
.index .follow {
  z-index: 100000;
}
.keep {
  text-align: center;
}
.hotList {
  .list {
    .btie {
      height: 4vw;
      line-height: 4vw;
      text-align: center;
      .label {
        color: #fff;
        background: #fc4142;
        width: 7.47vw;
        font-size: 2.4vw;
        border: 1px solid #fc4142;
      }
      .price {
        width: 15.2vw;
        color: #fc4142;
        border: 1px solid #fc4142;
      }
    }
  }
}
.top_nav {
  width: 100%;
  overflow: auto;
  padding: 0;
  &._bottom {
    // margin-bottom: -5vw;
  }
  > div {
    flex-wrap: nowrap;
    align-items: center;
    line-height: 10vw;
  }
  a {
    div {
      width: 20vw;
      height: 10vw;
      text-align: center;
      &.on {
        position: relative;
        color: #ff4142;
        &:after {
          content: "";
          position: absolute;
          width: 10vw;
          height: 0.5vw;
          background: #ff4142;
          bottom: 2vw;
          left: 0;
          right: 0;
          margin: 0 auto;
        }
      }
    }
  }
}
.pinktitle {
  width: 100%;
  padding: 5vw 2.57vw 0;
  .titleimg {
    width: 32vw;
    height: 6.67vw;
    margin: 0 31.3vw 5vw;
  }
  .pinklist {
    .pinkitem {
      background-color: #fff;
      margin-bottom: 2.67vw;
      width: 94.67vw;
      height: 38.67vw;
      padding: 2.7vw;
      border-radius: 3vw;
      .goodsimg {
        width: 33.2vw;
        height: 33.2vw;
        border-radius: 2vw;
      }
      .infos {
        width: 52vw;
        .store_name {
          font-size: 3.47vw;
          color: #333333;
          font-weight: 600;
        }
        .price_member {
          height: 13vw;
          align-items: center;
          .price {
            align-items: center;
            .price_1 {
              color: #fc4142;
              font-size: 3.47vw;
              text {
                font-size: 4.8vw;
              }
            }
            .ot_price {
              color: #999999;
              font-size: 3.2vw;
            }
          }
          .pinkmember {
            position: relative;
            width: 13.61vw;
            height: 5.07vw;
            .avatar {
              position: absolute;
              width: 5.07vw;
              height: 5.07vw;
              border-radius: 50%;
            }
          }
        }
        .btns {
          width: 52vw;
          height: 10.67vw;
          color: #fff;
          padding: 0 4vw 0 2.67vw;
          background-image: url("../../assets/images/btn_bg.png");
          background-size: 100% 100%;
          .left {
            font-size: 2.93vw;
          }
        }
      }
    }
  }
}
.mask_com {
  width: 80%;
  border-radius: 8px;
  background-color: #fff;
  .com_title {
    font-size: 5vw;
    text-align: center;
    padding: 3.75vw;
  }
  .com_com {
    font-size: 4vw;
    padding: 0 3.75vw;
  }
  .com_but {
    padding: 3.75vw;
    text-align: center;
    margin-top: 20px;
    border-top: 1px solid #f9f9f9;
  }
}

.claBox {
  width: 100%;
  overflow: auto;
  padding: 0;
  > div {
    flex-wrap: nowrap;
    align-items: center;
  }
  .claItem {
    display: inline-block;
    text-align: center;
    padding: 10px;
    &.claOn {
      color: #ff4142;
    }
    .claImg {
      width: 50px;
      height: 50px;
    }
  }
}
</style>
